import { takeLatest, call, put } from 'redux-saga/effects';
import URLS from '../constants/urls';
import { callApi, getWithoutBaseURL } from '../utils/api';

import * as Action from '../actions/commonAction';

import Base64 from '../constants/base64Encoding';

function* mobVerificationGenerateOTP({payload}) {
  try {
    const res = yield call(callApi, URLS.MN_VERIFICATION_OTP, 'post', payload);
    yield put(Action.setMobVerificationGenerateOtpRes(res));
  } catch (error) {
    yield put(Action.setMobVerificationGenerateOtpRes(error.data));
    // yield put(Action.openSnackbar(error.data.msg || "", 'error'));
    yield put(Action.setLoader(false));
  }
}

function* mobVerificationResendOTP({payload}) {
  try {
    const res = yield call(callApi, URLS.MN_RESEND_OTP, 'post', payload);
    yield put(Action.setMobVerificationResendOtpRes(res.consent_form));
    yield put(Action.setLoader(false));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* mobVerificationVerifyOTP({payload}) {
  try {
    const res = yield call(callApi, URLS.MN_VERIFY_OTP, 'post', payload);

    if(payload?.force_otp) {
      yield put(Action.setMobVerificationVerifyForceOtpRes(res));
    } else if(payload?.is_email) {
      yield put(Action.setEmailVerificationOtpRes(res));
    } else {
      yield put(Action.setMobVerificationVerifyOtpRes(res.msg));
    }
    yield put(Action.openSnackbar(res.msg));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* getCurrentState({payload}) {
  // const completedSteps = {
  //   // INITIATED: true,
  //   CONSENT_FORM: true,
  //   PAN_VERIFICATION: false,
  //   AADHAAR_VERIFICATION: true,
  //   SCHEDULE_CALL: true
  // };
  try {
    const res = yield call(callApi, URLS.GET_CURRENT_STATE, 'post', payload);
    sessionStorage.setItem(
      "happayVideoKyc.sessionId",
      res.session_id
    );
    sessionStorage.setItem(
      "happayVideoKyc.userId",
      res.user_id
    );

    yield put(Action.setCurrentState(res));
    yield put(Action.checkCompletedSteps(res.vkyc_steps_status));
    yield put(Action.setLoader(false));
  } catch (error) {
    yield put(Action.setCurrentState(error.data));
    yield put(Action.setLoader(false));
  }
}

function* updateKycType({payload}) {
  try {
    const res = yield call(callApi, URLS.UPDATE_KYC_TYPE, 'put', payload);
    yield put(Action.updateKycTypeRes(res));
    yield put(Action.setLoader(false));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* getConsentForm({payload}) {
  try {
    const res = yield call(callApi, URLS.CONSENT_FORM, 'get', payload);
    yield put(Action.setConsentData(res.consent_form));
    yield put(Action.checkCompletedSteps(res.vkyc_steps_status));
    yield put(Action.setLoader(false));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* submitConsentForm({payload}) {
  try {
    const res = yield call(callApi, URLS.CONSENT_FORM, 'post', payload);
    yield put(Action.checkCompletedSteps(res.vkyc_steps_status));
    yield put(Action.setLoader(false));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error', 10000));
    yield put(Action.setLoader(false));
  }
}

function* panVerification({payload}) {
  try {
    const panRes = yield call(callApi, URLS.PAN_VERIFICATION, 'post', payload);
    // const payloadForCKYC = {
    //   payload: {
    //     doc_type: "PAN",
    //     doc_id: payload.pan
    //   }
    // }
    // yield searchCKyc(payloadForCKYC, panRes);

    yield put(Action.checkCompletedSteps(panRes.vkyc_steps_status));
    yield put(Action.setLoader(false));
  } catch (error) {
    // if(error.data && error.data.error_code && error.data.error_code === 1000) {
    //   yield put(Action.panVerificationRes(error.data));
    // } else {
    if(error.data && error.data.error_code && error.data.error_code === 1012) {
      yield put(Action.panVerificationRes(error.data));
      const reqData = {
        doc_det: Base64.encode(payload?.pan),
        user_id: sessionStorage.getItem('happayVideoKyc.userId') || '',
      };
      yield put(Action.userPanNameUpdate(reqData));
    } else {
      yield put(Action.openSnackbar(error?.data?.msg, 'error'));
    }
    yield put(Action.setLoader(false));
  }
}

function* userPanNameUpdate({payload}) {
  yield put(Action.setLoader(true));
  try {
    const panNameRes = yield call(callApi, URLS.USER_PAN_NAME, 'post', payload);
    yield put(Action.userPanNameUpdateRes(panNameRes));
    yield put(Action.setLoader(false));
  } catch (error) {
    yield put(Action.openSnackbar(error?.data?.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* searchCKyc({payload}, panRes) {
  try {
    const res = yield call(callApi, URLS.SEARCH_CKYC, 'post', payload);
    if("ckyc_details" in res) {
      yield put(Action.setCkycRes(res));
    } else {
      yield put(Action.checkCompletedSteps(res.vkyc_steps_status));
    }
    yield put(Action.kycDeclined(null));
    yield put(Action.setLoader(false));
  } catch (error) {
    if(panRes) {
      yield put(Action.checkCompletedSteps(panRes.vkyc_steps_status));
    }
    if(error?.data?.msg?.includes("5 years old")) {
      yield put(Action.setOldCKycMsg(error?.data.msg));
    }
    if(error?.data?.retry_count > 3) {
      yield put(Action.hideCkycVerification({hideCkycVerification: true}));
    }
    yield put(Action.setCkycRes(`CKYC_NOT_FOUND_${error?.data?.retry_count}`));
    // err_code === KYC0001  means kyc is declined from 3rd Party
    if(error?.data?.err_code === "KYC0001") {
      yield put(Action.kycDeclined(error?.data));
    }
    yield put(Action.openSnackbar(error?.data?.msg, 'error', 10000));
    yield put(Action.setLoader(false));
  }
}

function* getCaptcha({payload}) {
  try {
    const res = yield call(callApi, URLS.GET_CAPTCHA, 'get', payload);
    yield put(Action.setCaptchaRes(res.security_code));
    yield put(Action.checkCompletedSteps(res.vkyc_steps_status));
    yield put(Action.setLoader(false));
  } catch (error) {
    if(error.data && error.data.error_code && error.data.error_code === 1003) {
      yield put(Action.setCaptchaRes(error.data.security_code));
    } else {
      yield put(Action.openSnackbar(error.data.msg, 'error'));
    }
    yield put(Action.setLoader(false));
  }
}

function* getOtp({payload}) {
  try {
    const res = yield call(callApi, URLS.GENERATE_EKYC_AADHAAR_OTP, 'post', payload);
    yield put(Action.setOtpRes({status: true, msg: ""}));
    yield put(Action.openSnackbar(res.msg));
    // yield put(Action.checkCompletedSteps(res.vkyc_steps_status));
    yield put(Action.setLoader(false));
  } catch (error) {
    //error.data.error_code === 1000 ===> "Aadhaar number entered is invalaid. Please try again."
    //error.data.error_code === 1002 ===> "Security code (captcha text) entered is invalid. Please try again."

    if(error.data && error.data.error_code && error.data.error_code !== 1000 && error.data.error_code !== 1002) {
      yield put(Action.openSnackbar(error.data.msg, 'error'));
    } else if(error.data.error_code) {
      yield put(Action.setOtpRes({status: false, msg: error.data.msg, err_code: error.data.error_code}));
    } else {
      yield put(Action.openSnackbar(error.data.msg, 'error'));
    }
   
    yield put(Action.setLoader(false));
  }
}

function* submitOtp({payload}) {
  try {
    const res = yield call(callApi, URLS.VALIDATE_EKYC_AADHAAR_OTP, 'post', payload);
    yield put(Action.submitOtpRes(res));
    yield put(Action.checkCompletedSteps(res.vkyc_steps_status));
  } catch (error) {
    // For 3 Wrong attemped OTP
    if(error.data && error.data.error_code && error.data.error_code === 1001) {
      yield put(Action.setOtpRes({status: false, msg: ""}));
      yield put(Action.setCaptchaRes(""));
      yield put(Action.otpMaxLimitExceededRes(true));
    } else if(error.data && error.data.error_code && error.data.error_code === 1000) {
      yield put(Action.submitOtpFailedRes(error.data.msg));
    } else {
      yield put(Action.openSnackbar(error.data.msg, 'error'));
    }
  
    yield put(Action.setLoader(false));
  }
}

function* confirmAadhaarXml({payload}) {
  try {
    const res = yield call(callApi, URLS.AADHAAR_XML_CONFIRM, 'post', payload);
    yield put(Action.checkCompletedSteps(res.vkyc_steps_status));
    yield put(Action.confirmAadhaarXmlRes(res));
    yield put(Action.kycDeclined(null));
    yield put(Action.setLoader(false));
  } catch (error) {
    // err_code === KYC0001  means kyc is declined from 3rd Party
    if(error?.data?.err_code === "KYC0001") {
      yield put(Action.kycDeclined(error?.data));
    }
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* getVideoLink({payload}) {
  try {
    const res = yield call(callApi, URLS.GET_VIDEO_LINK, 'get', payload);
    yield put(Action.setVideoLinkRes(true));
    window.open(res.redirect_url, "_self");
    yield put(Action.checkCompletedSteps(res.vkyc_steps_status));
    yield put(Action.setLoader(false));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* getZipCodeData({payload}) {
  try {
    const apiKey = '579b464db66ec23bdd000001db33706b81e8493e7f25caed02caf467';
    const resourcesId = '6176ee09-3d56-4a3b-8115-21841576b2f6';
    const url = `https://api.data.gov.in/resource/${resourcesId}?api-key=${apiKey}&format=json&filters[pincode]=${payload.zip}`;

    const response = yield call(getWithoutBaseURL, url);
    if(response &&
      response.records &&
      response.records.length === 0) {
        yield put(Action.zipCodeRes({
            statename: "", 
            districtname: "", 
            pinCodeErr: `Couldn't fetch! Enter the city and state manually.`
          })
        );
        // yield put(Action.openSnackbar("No data found for this pin code. Please provide the city and state manually!", 'error'));
    } else if(response && response.records && response.records.length > 0) {
      const addressObj = response.records[0];
      yield put(Action.zipCodeRes(addressObj));
    }
    yield put(Action.setLoader(false));
  } catch (error) {
    yield put(Action.zipCodeRes({
        statename: "", 
        districtname: "", 
        pinCodeErr: `Couldn't fetch! Enter the city and state manually.`
      })
    );
    // yield put(Action.openSnackbar("There is some issue with fetching data. Please provide the city and state manually!", 'error'));

    yield put(Action.setLoader(false));
  }
}

function* submitPoiPhoto({payload}) {
  try {
    const res = yield call(callApi, URLS.POI_PHOTO, 'post', payload);
    if(payload.get("doc_type") === "POI") {
      yield put(Action.poiRes(res.user_details.poi));
    } else {
      yield put(Action.photoRes(res.user_details.photo));
    }
    yield put(Action.setLoader(false));
  } catch (error) {
    if(error.status === 400 && error.data && error.data.error_code === 1000) {
      yield put(Action.checkPhotoLivenessFailedRes(error.data.msg));
    } else {
      yield put(Action.openSnackbar(error.data.msg, 'error'));
    }
    yield put(Action.setLoader(false));
  }
}

function* submitPoa({payload}) {
  try {
    const res = yield call(callApi, URLS.POA, 'post', payload);
    yield put(Action.poaRes(res.user_details));
    yield put(Action.setLoader(false));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* saveUserLocation({payload}) {
  try {
    const res = yield call(callApi, URLS.SAVE_USER_LOCATION, 'post', payload);
    yield put(Action.saveUserLocationRes(res.location_captured));
    // yield put(Action.setLoader(false));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* checkPhotoLiveness({payload}) {
  try {
    const res = yield call(callApi, URLS.CHECK_PHOTO_LIVENESS, 'post', payload);
    yield put(Action.checkCompletedSteps(res.vkyc_steps_status));
    yield put(Action.fetchMetaFields({}));
    yield put(Action.setLoader(false));
  } catch (error) {
    // yield put(Action.openSnackbar(error.data.msg, 'error'));
    if(error.status === 400 && error.data.error_code === 1000) {
      yield put(Action.checkPhotoLivenessFailedRes(error.data.msg));
    } else  {
      yield put(Action.openSnackbar(error.data.msg, 'error'));
    }
    yield put(Action.setLoader(false));
  }
}

function* confirmCkycAddress({payload}) {
  try {
    const res = yield call(callApi, URLS.CKYC_ADDRESS_CONFIRM, 'post', payload);
    yield put(Action.checkCompletedSteps(res.vkyc_steps_status));
    yield put(Action.confirmCkycAddressRes(res));
    yield put(Action.kycDeclined(null));
    yield put(Action.setLoader(false));
  } catch (error) {
    if(error?.data?.msg?.includes("5 years old")) {
      yield put(Action.setOldCKycMsg(error?.data.msg));
    }
    if(error?.data?.err_code === "KYC0001") {
      yield put(Action.kycDeclined(error?.data));
    }
    yield put(Action.openSnackbar(error.data.msg, 'error', 10000));
    yield put(Action.setLoader(false));
  }
}

function* generateKarzaOtp({payload}) {
  try {
    const res = yield call(callApi, URLS.GENERATE_AADHAAR_OTP, 'post', payload);
    yield put(Action.generateKarzaOtpRes(res));
    yield put(Action.openSnackbar(res.msg));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* submitKarzaOtp({payload}) {
  try {
    const res = yield call(callApi, URLS.SUBMIT_AADHAAR_OTP, 'post', payload);
    yield put(Action.submitOtpRes(res));
    yield put(Action.checkCompletedSteps(res.vkyc_steps_status));
    yield put(Action.kycDeclined(null));
  } catch (error) {
    // err_code === KYC0001  means kyc is declined from 3rd Party
    if(error?.data?.err_code === "KYC0001") {
      yield put(Action.kycDeclined(error?.data));
    }
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* quickKycGenerateOtp({payload}) {
  try {
    const res = yield call(callApi, URLS.QUICK_KYC_GENERATE_OTP, 'post', payload);
    yield put(Action.quickKycGenerateOtpRes(res));
    yield put(Action.openSnackbar(res?.msg));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* confirmAdditionalFields({payload}) {
  try {
    const res = yield call(callApi, URLS.USER_ADDITIONAL_DETAILS, 'post', payload);
    yield put(Action.confirmAdditionalFieldsRes(res));
    yield put(Action.checkCompletedSteps(res.vkyc_steps_status));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* quickKycValidateOtp({payload}) {
  try {
    const res = yield call(callApi, URLS.QUICK_KYC_VALIDATE_OTP, 'post', payload);
    yield put(Action.quickKycValidateOtpRes(res));
    yield put(Action.openSnackbar(res?.msg));
    // yield put(Action.checkCompletedSteps(res.vkyc_steps_status));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* createCif({payload}) {
  try {
    const res = yield call(callApi, URLS.CREATE_CIF, 'post', payload);
    yield put(Action.createCifRes(res));
    yield put(Action.checkCompletedSteps(res.vkyc_steps_status));
  } catch (error) {
    // err_code === CIF0001  means CIF creation is pening with bank
    if(error?.data?.err_code === "CIF0001") {
      yield put(Action.createCifRes(error?.data));
    }
    yield put(Action.createCifRes({status: "failed"}));
    // yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* pennyDropVerification({payload}) {
  try {
    const res = yield call(callApi, URLS.PENNY_DROP, 'post', payload);
    yield put(Action.pennyDropVerificationRes(res));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* quickKycVerify({payload}) {
  try {
    const res = yield call(callApi, URLS.QUICK_KYC_VERIFY, 'post', payload);
    yield put(Action.quickKycVerifyRes(res));
    // yield put(Action.checkCompletedSteps(res.vkyc_steps_status));
  } catch (error) {
    yield put(Action.quickKycVerifyFailRes({}));
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}
function* fetchMetaFields({payload}) {
  try {
    const res = yield call(callApi, URLS.FETCH_META_FIELDS, 'get', payload);
    yield put(Action.fetchMetaFieldsRes(res));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
  }
}

function* setMetaFields({payload}) {
  try {
    const res = yield call(callApi, URLS.SET_META_FIELDS, 'post', payload);
    yield put(Action.checkCompletedSteps(res.vkyc_steps_status));
    yield put(Action.setLoader(false));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* hdfcVkycPanVerification({payload}) {
  try {
    const res = yield call(callApi, URLS.HDFC_VKYC_PAN_VERIFICATION, 'post', payload);
    yield put(Action.hdfcVkycPanVerificationRes(res));
    yield put(Action.setLoader(false));
    yield put(Action.openSnackbar(res?.msg));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* setHdfcAdditionalData({payload}) {
  try {
    const res = yield call(callApi, URLS.HDFC_VKYC_ADDITIONAL_DETAILS, 'post', payload);
    yield put(Action.setHdfcAdditionalDataRes(res));
    yield put(Action.setLoader(false));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* getHdfVkycUserDetails({payload}) {
  try {
    const res = yield call(callApi, URLS.HDFC_VKYC_USER_DETAILS, 'get', payload);
    yield put(Action.fetchHdfVkycUserDetailsRes(res));
    yield put(Action.setLoader(false));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* getHdfcEKycToken({payload}) {
  try {
    const res = yield call(callApi, URLS.HDFC_EKYC, 'post', payload);
    yield put(Action.hdfcBankEKYCRes(res));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* hdfcBankStepDetails({payload}) {
  try {
    const res = yield call(callApi, URLS.HDFC_COMPLETED_STEPS, 'post', payload);
    yield put(Action.hdfcBankStepDetailsRes(res));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* hdfcBankAddressConfirmation({payload}) {
  try {
    const res = yield call(callApi, URLS.HDFC_VKYC_ADDRESS_CONFIRMATION, 'post', payload);
    yield put(Action.setHdfcBankAddressConfirmationRes(res));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* hdfcVkycConsent({payload}) {
  try {
    const url = `${URLS.CONSENT_FORM_LANGUAGE}/${payload?.selectedLang}`;
    const res = yield call(callApi, url, 'get', payload);
    yield put(Action.getHdfcVkycConsentRes(res));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* hdfcVkycConsentAccept({payload}) {
  try {
    const res = yield call(callApi, URLS.CONSENT_FORM_LANGUAGE, 'post', payload);
    yield put(Action.hdfcBankVKycLink({}, "You are being redirected to an external page"));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}

function* getHdfcVKycLink({payload}) {
  try {
    const res = yield call(callApi, URLS.HDFC_VKYC, 'post', payload);
    yield put(Action.hdfcBankVKycRes(res));
  } catch (error) {
    yield put(Action.openSnackbar(error.data.msg, 'error'));
    yield put(Action.setLoader(false));
  }
}


export function* commonSaga() {
  yield takeLatest('GENERATE_MOBILE_VERIFICATION_OTP', mobVerificationGenerateOTP);
  yield takeLatest('MOBILE_VERIFICATION_RESEND_OTP', mobVerificationResendOTP);
  yield takeLatest('MOBILE_VERIFICATION_VERIFY_OTP', mobVerificationVerifyOTP);
  yield takeLatest('GET_CURRENT_STATE', getCurrentState);
  yield takeLatest('UPDATE_KYC_TYPE', updateKycType);
  yield takeLatest('GET_CONSENT_FORM', getConsentForm);
  yield takeLatest('SUBMIT_CONSENT_FORM', submitConsentForm);
  yield takeLatest('PAN_VERIFICATION', panVerification);
  yield takeLatest('USER_PAN_NAME_UPDATE', userPanNameUpdate);  
  yield takeLatest('GET_CAPTCHA', getCaptcha);
  yield takeLatest('GET_OTP', getOtp);
  yield takeLatest('SUBMIT_OTP', submitOtp);
  yield takeLatest('GET_VIDEO_LINK', getVideoLink);
  yield takeLatest('POI_PHOTO', submitPoiPhoto);
  yield takeLatest('SUBMIT_POA', submitPoa);
  yield takeLatest('GET_ZIP_CODE_DATA', getZipCodeData);
  yield takeLatest('CONFIRM_AADHAAR_XML', confirmAadhaarXml);
  yield takeLatest('SAVE_USER_LOCATION', saveUserLocation);
  yield takeLatest('CHECK_PHOTO_LIVENESS', checkPhotoLiveness);
  yield takeLatest('CONFIRM_CKYC_ADDRESS', confirmCkycAddress);
  yield takeLatest('SEARCH_CKYC', searchCKyc);
  yield takeLatest('GENERATE_KARZA_OTP', generateKarzaOtp);
  yield takeLatest('SUBMIT_KARZA_OTP', submitKarzaOtp);
  yield takeLatest('QUICK_KYC_GENERATE_OTP', quickKycGenerateOtp);
  yield takeLatest('QUICK_KYC_VALIDATE_OTP', quickKycValidateOtp);
  yield takeLatest('QUICK_KYC_VERIFY', quickKycVerify);
  yield takeLatest('CONFIRM_ADDITIONAL_FIELDS', confirmAdditionalFields);
  yield takeLatest('CREATE_CIF', createCif);
  yield takeLatest('VERIFY_PENNY_DROP', pennyDropVerification);
  yield takeLatest('FETCH_META_FIELDS', fetchMetaFields);
  yield takeLatest('SET_META_FIELDS', setMetaFields);
  yield takeLatest('HDFC_VKYC_PAN_VERIFICATION', hdfcVkycPanVerification);
  yield takeLatest('HDFC_VKYC_ADDITIONAL_DATA', setHdfcAdditionalData);
  yield takeLatest('HDFC_BANK_VKYC_USER_DETAILS', getHdfVkycUserDetails);
  yield takeLatest('HDFC_BANK_EKYC', getHdfcEKycToken);
  yield takeLatest('HDFC_BANK_STEP_DETAILS', hdfcBankStepDetails);
  yield takeLatest('HDFC_BANK_ADDRESS_CONFIRMATION', hdfcBankAddressConfirmation);
  yield takeLatest('HDFC_VKYC_CONSENT', hdfcVkycConsent);
  yield takeLatest('HDFC_VKYC_CONSENT_ACCEPT', hdfcVkycConsentAccept);
  yield takeLatest('HDFC_BANK_VKYC', getHdfcVKycLink);
}
